import { z } from 'zod';
import { slugSchema } from './product.schema.js';

export const categoryCreateSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(150),
  slug: slugSchema,
  description: z.string().nullable().optional(),
  imageUrl: z.string().url().nullable().optional(),
  parentId: z.string().uuid().nullable().optional(),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});

export const categoryUpdateSchema = categoryCreateSchema.partial();

export type CategoryCreateInput = z.infer<typeof categoryCreateSchema>;
export type CategoryUpdateInput = z.infer<typeof categoryUpdateSchema>;
